export default "assets/images/texture-84813d6e.png";